import { Autocomplete, Grid, TextField } from "@mui/material";
import { Fragment } from "react";
import { DesktopDatePickerLight } from "../../../common/components/styled/styled";
import { AutocompleteType } from "../../../common/types/autoComplete";
import { CustomerCC } from "../../customer/types/queries";
import OrderFormShortHeaderRow from "../newOrder/short/OrderFormShortHeaderRow";
import OrderTimeField from "../OrderTimeField";
import { ValidationError } from "../orderTypes";
import { OrderFormShortRowGridItem } from "../styles";
import { FillShiftSelection } from "./FillShiftSelection";
import { OrderFieldsProperties, ShiftDetailsType } from "./types";

type Props = {
  costCenters: CustomerCC[];
  shiftDetailValues: ShiftDetailsType[];
  validationErrors: ValidationError[];
  handleShiftDetailsChange: (
    name: string,
    value: Date | null | string | AutocompleteType | boolean,
    id: string,
  ) => void;
  handleChangeCallback: (
    name: OrderFieldsProperties,
    newValue:
      | AutocompleteType[]
      | AutocompleteType
      | Date
      | null
      | number
      | string
      | boolean,
  ) => void;
};

const ShiftDetails = ({
  costCenters,
  shiftDetailValues,
  validationErrors,
  handleShiftDetailsChange,
  handleChangeCallback = () => {}, //TODO: strong typing
}: Props) => {
  const headers = [
    { label: "date", width: "140px", textAlign: "center" },
    { label: "time", width: "165px", textAlign: "center" },
    { label: "customerCostCenter", width: "218px", textAlign: "center" },
  ];

  const costCenterOptions: AutocompleteType[] = costCenters.map(
    (costCenter) => ({ id: costCenter.customerCCId, name: costCenter.name }),
  );

  return (
    <>
      <Grid xs={4} item />
      <Grid container item xs={8} direction="row" spacing={1} mb={2}>
        <OrderFormShortHeaderRow headers={headers} />
        {shiftDetailValues.map((row) => (
          <Fragment key={row.id}>
            <OrderFormShortRowGridItem item width="150px">
              {/* TODO FIXME check if date can be formatted with weekday */}
              <DesktopDatePickerLight
                format={
                  row?.date?.toLocaleDateString().length === 10
                    ? "dd.MM.yyyy"
                    : "dd.MM.yyyy"
                }
                value={row.date}
                onChange={(value: any) =>
                  handleShiftDetailsChange("date", value, row.id)
                }
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    name: "date",
                    sx: { backgroundColor: "rgba(249, 249, 250, 0.6)" },
                  },
                }}
              />
            </OrderFormShortRowGridItem>
            <OrderFormShortRowGridItem item width="165px">
              <OrderTimeField
                id={row.id}
                value={row.time}
                disabled={false}
                validationErrors={validationErrors}
                onChange={(value) =>
                  handleShiftDetailsChange("time", value, row.id)
                }
              />
            </OrderFormShortRowGridItem>
            <OrderFormShortRowGridItem item width="218px">
              <Autocomplete
                value={row.customerCostCenter}
                sx={{ backgroundColor: "rgba(249, 249, 250, 0.6)" }}
                options={costCenterOptions}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    name="customerCostCenter"
                  />
                )}
                onChange={(_, newValue: AutocompleteType | null) =>
                  handleShiftDetailsChange(
                    "customerCostCenter",
                    newValue,
                    row.id,
                  )
                }
              />
            </OrderFormShortRowGridItem>
            <FillShiftSelection
              value={!!row.isFillShift}
              onChange={(value) =>
                handleShiftDetailsChange("isFillShift", value, row.id)
              }
            />
          </Fragment>
        ))}
      </Grid>
    </>
  );
};

export default ShiftDetails;
